import { render, staticRenderFns } from "./VendorsList.vue?vue&type=template&id=00203c85&"
import script from "./VendorsList.vue?vue&type=script&lang=ts&"
export * from "./VendorsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports